// extracted by mini-css-extract-plugin
module.exports = {"ModalBody":"_24Cgm6qH"};